import { t } from "./i18n";
import { X } from "lucide-react";

export function ShortcutHelpDialog({ onClose }: { onClose: () => void }) {
  const shortcuts = [
    ["⌘/Ctrl + Enter", "Send message"],
    ["Shift + Enter", "Insert newline"],
    ["Esc", "Dismiss menus or cancel autocomplete"],
    ["⌘/Ctrl + K", "Focus the composer"],
    ["⌘/Ctrl + Shift + C", "Copy the latest answer"],
    ["⌘/Ctrl + Shift + R", "Regenerate the latest answer"],
    ["⌘/Ctrl + S", "Stop generation"],
    ["⌘/Ctrl + ↑/↓", "Navigate conversation history"],
    ["⌘/Ctrl + Shift + O", "Toggle the sidebar"],
    ["F1", "Open or close this help"],
  ];
  return (
    <div
      className="fixed inset-0 z-50 grid place-items-center bg-black/50 p-4"
      onMouseDown={(event) => event.target === event.currentTarget && onClose()}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="shortcut-help-title"
        className="w-full max-w-md rounded-2xl border border-stone-200 bg-white p-5 shadow-2xl dark:border-white/10 dark:bg-stone-900"
      >
        <div className="flex items-center justify-between">
          <h2 id="shortcut-help-title" className="font-bold">
            {t("Keyboard shortcuts")}
          </h2>
          <button type="button" className="button p-1.5" onClick={onClose}>
            <X size={16} />
          </button>
        </div>
        <div className="mt-4 divide-y divide-stone-100 dark:divide-white/10">
          {shortcuts.map(([shortcut, label]) => (
            <div
              key={shortcut}
              className="flex items-center justify-between gap-4 py-2.5 text-sm"
            >
              <span className="text-stone-600 dark:text-stone-300">
                {label}
              </span>
              <kbd className="shrink-0 rounded-md border border-stone-200 bg-stone-50 px-2 py-1 font-mono text-xs text-stone-500 dark:border-white/10 dark:bg-white/5 dark:text-stone-400">
                {shortcut}
              </kbd>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
